import React from "react";
import { IconCheck } from "./icons";

// Horizontal progress stepper. `titles` is an array of step labels;
// `current` is the 1-based active step.
const Stepper = ({ titles = [], current = 1 }) => (
  <div className="crs-stepper" aria-label={`Step ${current} of ${titles.length}`}>
    {titles.map((title, i) => {
      const n = i + 1;
      const state = n < current ? "is-done" : n === current ? "is-active" : "";
      return (
        <div key={title} className={`crs-stepper__item ${state}`}>
          <span className="crs-stepper__dot">
            {n < current ? <IconCheck /> : n}
          </span>
          <span className="crs-stepper__label">{title}</span>
        </div>
      );
    })}
  </div>
);

export default Stepper;
